import React, {useEffect, useState} from 'react';
import '../../styles/filterpanel.css';
import {MDBCard, MDBCardBody, MDBCardText, MDBCol, MDBRow} from 'mdb-react-ui-kit';
import SelectDropdown from "./SelectDropdownComponent";
import {Button} from "semantic-ui-react";
import DateFields from "./DateFieldsComponents";
import Modal from 'react-bootstrap/Modal';
import ExportService from "../Services/Bll/ExportService";
import KpiService from "../Services/Bll/KpiService";
import {useFilterDatesContext} from "../Context/FilterDatesContext";
import {useFilterDataContext} from "../Context/FilterDataContext";
import {MoreFiltersComponent} from "./MoreFiltersComponent";

export const ExportModal = ({props}) => {
    const {filteredData} = useFilterDataContext();
    const {dates} = useFilterDatesContext();
    const [showFilters, setShowFilters] = useState(false);
    const toggleFilters = () => {
        setShowFilters(!showFilters);
    };

    useEffect(() => {
        KpiService.checkHasValideDate(dates)
    }, [dates]);

    const handleSubmit = async () => {
        const exportService = new ExportService();
        const {isAllValid} = KpiService.checkHasValideDate(dates);
        if (!isAllValid) {
            return;
        }

        try {
            const queryParameters = {dates, filteredData, shouldCapitalize: true};
            const query = KpiService.getFilterQuery(queryParameters)
            console.log(query)
            const response = await exportService.getDataToExport(query)
            const exportValue = response.data.data;
            ExportService.exportToExcel({data: exportValue, fileName: 'export'})
        } catch (error) {
            console.error("Erreur:", error);
            alert("Échec de l'export");
        }
    };

    const renderFilterSummary = () => {
        const activeFilters = Object.entries(filteredData)
            .map(([key]) => key.replace("Data", ""));

        if (!activeFilters.length) return null;

        return (
            <div className="filter-summary" style={{
                marginTop: "1rem",
                padding: "0.5rem",
                border: "1px solid #ccc",
                borderRadius: "5px",
                backgroundColor: "#f9f9f9"
            }}>
                <strong>Filtres actifs :</strong> {activeFilters.join(", ")}
            </div>);
    };

    return (<>
            <Modal.Header closeButton>
                <Modal.Title>Configuration de l'export</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <MDBCard>
                    <MDBCardBody className="mx-2">
                        <MDBRow className="m-2 justify-content-center" xxl={12}>
                            <MDBCol xxl={7} xl={8} md={12}>
                                <MDBCardText>
                                    <DateFields/>
                                </MDBCardText>
                            </MDBCol>
                            <MDBCol xl={1} md={0}/>
                            <MDBCol xxl={4} xl={4} sm={12} className="exportButtonContainer">
                                <div className="d-flex justify-content-center">
                                    <Button onClick={toggleFilters}
                                            className="button moreFilterButton my-xxl-0 my-md-2">Plus de
                                        filtres</Button>
                                </div>
                                {renderFilterSummary()}
                            </MDBCol>
                        </MDBRow>
                        <MDBRow className="my-4" style={{display: showFilters ? 'block' : 'none'}}>
                            <MoreFiltersComponent/>
                        </MDBRow>
                        <MDBRow >
                            <div className="d-flex justify-content-start">
                                <SelectDropdown autocompleteWidth="100%"
                                                title={'Sélection des champs'}
                                                defaultData={JSON.parse(localStorage.getItem('exportField'))}/>
                            </div>
                        </MDBRow>
                    </MDBCardBody>
                </MDBCard>
            </Modal.Body>
            <Modal.Footer>
                <Button className="mx-auto" variant="secondary" onClick={() => handleSubmit(true)}
                        style={{width: '150px'}}>
                    Valider
                </Button>
            </Modal.Footer>
        </>
    );
}
